module.exports = __webpack_public_path__ + "static/img/volcano.b922996.jpg";